<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="catalogo_aocs">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="red darken-4">
                        <v-toolbar-title>Asignaturas Optativas Complementarias&nbsp;&nbsp;</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="(bEditPlan || bEditPackage || bEditCourse)"
                                text
                                class="text-none"
                                @click="onNewPlan"
                            >Nuevo Plan</v-btn>
                            <v-btn
                                :disabled="(bEditPlan || bEditPackage || bEditCourse || planID === 0)"
                                text
                                class="text-none"
                                @click="onEditPlan"
                            >Editar Plan</v-btn>
                            <v-btn
                                :disabled="(bEditPlan || bEditPackage || bEditCourse || planID === 0 )"
                                text
                                class="text-none"
                                @click="onDeletePlan"
                            >Borrar Plan</v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text :disabled="(bEditPlan || bEditPackage || bEditCourse)" @click="onClose" v-on="on">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="(bEditPlan || bEditPackage || bEditCourse)" @click="onNewPlan">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-map-plus</v-icon>&nbsp; Nuevo Plan
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="(bEditPlan || bEditPackage || bEditCourse || planID === 0)" @click="onEditPlan">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-pencil</v-icon>&nbsp; Editar Plan
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="(bEditPlan || bEditPackage || bEditCourse || planID === 0)" @click="onDeletePlan">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-map-minus</v-icon>&nbsp; Borrar Plan
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="(bEditPlan || bEditPackage || bEditCourse)" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de planes y plan seleccionado: -->
                    <v-container fluid grid-list-md class="mx-auto">
                        <!-- Renglón único para lista de planes y card de plan seleccionado: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de Planes: *************************** -->
                            <v-flex xs11 md2>
                                <v-card>
                                    <v-toolbar dense color="red darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title">Planes</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-format-list-bulleted</v-icon>
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="planListHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        color="grey lighten-4"
                                        :disabled="(loadingData || bEditPlan || bEditPackage || bEditCourse)"
                                    >
                                        <v-list-item-group
                                            v-model="selectedPlanIndex"
                                            color="orange accent-4"
                                            :mandatory="!bNewPlan"
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(plan, i) in planesEstudios"
                                                :key="i"
                                                @click="selectPlan(plan.planid)"
                                            >
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex
                                                                    md2
                                                                    xs6
                                                                >{{ plan.plan }}</v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Planes ********************************* -->

                            <!-- Info de plan seleccionado: *********************** -->
                            <v-flex xs11 md10>
                                <v-card class="grey lighten-3" ref="plan_card">

                                    <v-toolbar :height="planToolbarHeight" color="red lighten-3" flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >{{ selectedPlanName }}</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-map-outline</v-icon>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout wrap>
                                                <v-flex xs12 md5>
                                                     <v-text-field
                                                        dense
                                                        name="nombrePlan"
                                                        label="Nombre del plan"
                                                        type="text"
                                                        v-model="nombrePlan"
                                                        :readonly="!bEditPlan"
                                                        color="red darken-3"
                                                        ref="plan_name_field"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs6 md2>
                                                    <v-text-field
                                                        dense
                                                        prepend-icon="mdi-calendar-month"
                                                        label="Año de inicio"
                                                        type="number"
                                                        v-model="anioInicio"
                                                        :readonly="!bEditPlan"
                                                        color="red darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs6 md2>
                                                    <v-select
                                                        dense
                                                        :items="seasons"
                                                        item-text="term"
                                                        item-value="termID"
                                                        v-model="periodoInicioID"
                                                        :readonly="!bEditPlan"
                                                        label="Periodo"
                                                        color="red darken-4"
                                                        item-color="red darken-4"
                                                        reverse
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEditPlan"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSavePlan"
                                                        :disabled="!bEditPlan"
                                                    >Guardar Plan de Estudios</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancelEditPlan"
                                                        :disabled="!bEditPlan"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout wrap justify-space-around>
                                                <v-flex xs11 md5>
                                                    <v-card>
                                                        <v-toolbar height="30" color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">División</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-file-tree-outline</v-icon>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="divisionListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="(loadingData || bEditPlan || bEditPackage || bEditCourse)"
                                                        >
                                                            <v-list-item-group
                                                                v-model="selectedDivisionIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(division, i) in divisiones"
                                                                    :key="i"
                                                                    @click="selectDivision(division.divisionid)"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ division.nombre }} - {{ division.sigla }} </v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs11 md6>
                                                    <v-card>
                                                        <v-toolbar height="30" color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">Departamento</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-home-outline</v-icon>
                                                        </v-toolbar>
                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="divisionListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="(loadingData || bEditPlan || bEditPackage || bEditCourse)"
                                                        >
                                                            <v-list-item-group
                                                                v-model="selectedDepartmentIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(department, i) in departamentos"
                                                                    :key="i"
                                                                    @click="selectDepartment(department.departamentoid)"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ department.nombre }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout wrap justify-space-around>
                                                <v-flex xs11 md5>
                                                    <v-card>
                                                        <v-toolbar height="30" color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">Programa o Servicio Departamental</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-school</v-icon>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="divisionListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="(loadingData || bEditPlan || bEditPackage || bEditCourse)"
                                                        >
                                                            <v-list-item-group
                                                                v-model="selectedProgramIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(program, i) in programas"
                                                                    :key="i"
                                                                    @click="selectProgram(program.programaid)"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ program.nombre }} </v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs11 md6>
                                                    <v-card>
                                                        <v-toolbar height="30" color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">Paquete</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-menu offset-y>
                                                                <template v-slot:activator="{
                                                                    on,}"
                                                                >
                                                                    <v-btn icon v-on="on" :disabled="bEditPlan || bEditPackage || bEditCourse">
                                                                        <v-icon color="white">mdi-dots-vertical</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-list color="pink lighten-5">
                                                                    <v-list-item @click="onNewPackage">
                                                                        <v-list-item-title>
                                                                            <v-icon color="red darken-2">mdi-book-plus</v-icon>
                                                                                &nbsp;Nuevo Paquete
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                    <v-list-item @click="onEditPackage" :disabled="packageID === 0">
                                                                        <v-list-item-title>
                                                                            <v-icon color="red darken-2" :disabled="packageID === 0">mdi-book-edit</v-icon>
                                                                                &nbsp;Editar Paquete
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                    <v-list-item @click="onDeletePackage" :disabled="packageID == 0">
                                                                        <v-list-item-title>
                                                                            <v-icon color="red darken-2" :disabled="packageID === 0">mdi-book-minus</v-icon>
                                                                                &nbsp;Borrar Paquete
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </v-toolbar>
                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="divisionListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="(loadingData || bEditPlan || bEditPackage || bEditCourse)"
                                                        >
                                                            <v-list-item-group
                                                                v-model="selectedPaqueteIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(paquete, i) in paquetesPrograma"
                                                                    :key="i"
                                                                    @click="selectPackage(paquete.paqueteid)"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ paquete.nombre }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <br />

                                            <v-divider
                                                class="red darken-4"
                                            ></v-divider>
                                            
                                            <br />

                                            <v-layout row>
                                                <v-flex xs12>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="red--text text--darken-3 body-1"
                                                        >
                                                            <v-icon
                                                                color="red darken-3"
                                                                >mdi-book-outline</v-icon
                                                            >&nbsp;Detalles del paquete
                                                        </span>
                                                    </div>
                                                </v-flex>
                                                
                                            </v-layout>

                                            <v-layout row>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        dense
                                                        label="Nombre del paquete"
                                                        type="text"
                                                        v-model="packageName"
                                                        :readonly="!bEditPackage"
                                                        color="red darken-3"
                                                        ref="package_name_field"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs6>
                                                    <v-card>
                                                        <v-toolbar height="30" color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">Programas que coordinan el paquete</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-menu offset-y>
                                                                <template v-slot:activator="{
                                                                    on,}"
                                                                >
                                                                    <v-btn icon v-on="on" :disabled="!bEditPackage">
                                                                        <v-icon color="white">mdi-dots-vertical</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <v-list color="pink lighten-5">
                                                                    <v-list-item @click="onAddProgram">
                                                                        <v-list-item-title>
                                                                            <v-icon color="red darken-2">mdi-book-plus</v-icon>
                                                                                &nbsp;Agregar Programa
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                    <!-- No se permite borrar un programa si el paquete sólo tiene un programa: -->
                                                                    <v-list-item @click="onDeleteProgram" :disabled="(selectedPackageProgramID == 0 || packagePrograms.length ===1)">
                                                                        <v-list-item-title>
                                                                            <v-icon color="red darken-2" :disabled="(selectedPackageProgramID == 0 || packagePrograms.length ===1)">mdi-book-minus</v-icon>
                                                                                &nbsp;Quitar Programa
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </v-list>
                                                            </v-menu>
                                                        </v-toolbar>
                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="divisionListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="(bEditPlan)"
                                                        >
                                                        <!-- :disabled="(loadingData || bEditPlan || !bEditCourse)" -->
                                                            <v-list-item-group
                                                                v-model="selectedPackageProgramIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(program, i) in packagePrograms"
                                                                    :key="i"
                                                                    @click="selectPackageProgram(program.programaid)"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ program.nombre }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs6>
                                                    <v-container>
                                                        <v-layout row justify-space-around>
                                                            <v-flex xs12 class="text-center">
                                                                <img :height="photoHeight" :src="packageImg" />
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row justify-space-around>
                                                            <v-flex align-self-center class="justify-center text-center" xs12>
                                                                <v-btn
                                                                    color="teal darken-3"
                                                                    class="text-none"
                                                                    text
                                                                    @click="onChangePackageImg"
                                                                    :disabled="!bEditPackage || bNewPackage"
                                                                >
                                                                    <span v-if="bPhoto === false">
                                                                        Agregar foto
                                                                    </span>
                                                                    <span v-else>
                                                                        Cambiar foto
                                                                    </span>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row justify-center>
                                                            <v-flex align-self-center class="justify-center text-center" xs12>
                                                                <v-btn
                                                                    color="pink darken-1"
                                                                    class="text-none"
                                                                    text
                                                                    @click="onDeletePackageImg"
                                                                    :disabled="!bPhoto || !bEditPackage"
                                                                >
                                                                    Borrar foto
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs6>
                                                    <v-textarea
                                                        dense
                                                        outlined
                                                        v-model="packageDescription"
                                                        :auto-grow="false"
                                                        no-resize
                                                        color="red darken-3"
                                                        label="Descripción"
                                                        rows="4"
                                                        :readonly="!bEditPackage"
                                                    ></v-textarea>
                                                </v-flex>        
                                                <v-flex xs6>
                                                    <v-textarea
                                                        dense
                                                        outlined
                                                        v-model="packageNotes"
                                                        :auto-grow="false"
                                                        no-resize
                                                        color="red darken-3"
                                                        label="Notas"
                                                        rows="4"
                                                        :readonly="!bEditPackage"
                                                    ></v-textarea>
                                                </v-flex>                                                
                                            </v-layout>
                                            <v-layout
                                                v-if="bEditPackage"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSavePackage"
                                                        :disabled="!bEditPackage"
                                                    >OK</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancelEditPackage"
                                                        :disabled="!bEditPackage"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs6>
                                                    <div class="text-xs-left">
                                                        <span
                                                            class="red--text text--darken-2 body-1"
                                                        >
                                                            <v-icon
                                                                color="red darken-2"
                                                                >mdi-book-outline</v-icon
                                                            >&nbsp;Materias del paquete
                                                        </span>
                                                    </div>
                                                </v-flex>
                                                <v-flex xs6 class="text-right">
                                                    <v-toolbar
                                                        height="30"
                                                        color="grey lighten-3"
                                                        flat
                                                    >
                                                        <v-spacer></v-spacer>
                                                        <v-menu offset-y>
                                                            <template v-slot:activator="{
                                                                on,}"
                                                            >
                                                                <v-btn icon v-on="on" :disabled="bEditPlan || bEditPackage || bEditCourse">
                                                                    <v-icon color="red darken-2">mdi-dots-vertical</v-icon>
                                                                </v-btn>
                                                            </template>
                                                            <v-list color="pink lighten-5">
                                                                <v-list-item @click="onNewCourse">
                                                                    <v-list-item-title>
                                                                        <v-icon color="red darken-2">mdi-book-plus</v-icon>
                                                                            &nbsp;Nueva Materia
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                            <v-list color="pink lighten-5">
                                                                <v-list-item @click="onEditCourse">
                                                                    <v-list-item-title>
                                                                        <v-icon color="red darken-2">mdi-book-edit</v-icon>
                                                                            &nbsp;Editar Materia
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                            <v-list color="pink lighten-5">
                                                                <v-list-item @click="onDeleteCourse">
                                                                    <v-list-item-title>
                                                                        <v-icon color="red darken-2">mdi-book-minus</v-icon>
                                                                            &nbsp;Borrar Materia
                                                                    </v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                    </v-toolbar>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap justify-space-around>
                                                <v-flex xs12 md4>
                                                    <v-card>
                                                        <v-toolbar :height="courseToolbarHeight" color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">Materias</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-text-field
                                                                hide-details
                                                                single-line
                                                                v-model="searchText"
                                                                dense
                                                                :disabled="bEditPlan || bEditCourse"
                                                            ></v-text-field>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn :disabled="bEditPlan || bEditCourse" small icon @click="onSearchCourse" v-on="on">
                                                                        <v-icon>mdi-magnify</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Buscar por nombre o clave</span>
                                                            </v-tooltip>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="courseListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="(loadingData || bEditPlan || bEditCourse)"
                                                        >
                                                            <v-list-item-group
                                                                v-model="selectedCourseIndex"
                                                                color="orange accent-4"
                                                                :mandatory="!bNewCourse"
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(materia, i) in materiasPaquete"
                                                                    :key="i"
                                                                    @click="selectCourse(materia.materiaid)"
                                                                    :id="materia.materiaid"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ materia.materia }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs12 md8>
                                                    <v-card ref="course_card">
                                                        
                                                        <v-toolbar :height="courseToolbarHeight" color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">{{ selectedCourseName }}</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-clipboard-text</v-icon>
                                                        </v-toolbar>

                                                        <v-card-text>
                                                            <v-container fluid>
                                                                <v-layout wrap>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            dense
                                                                            name="nombreMateria"
                                                                            label="Nombre de la materia"
                                                                            type="text"
                                                                            v-model="nombreMateria"
                                                                            :readonly="!bEditCourse"
                                                                            color="red darken-3"
                                                                            ref="materia_name_field"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row>
                                                                    <v-flex xs6 sm3 md3>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Clave"
                                                                            type="text"
                                                                            v-model="clave"
                                                                            :readonly="!bEditCourse"
                                                                            color="red darken-3"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs4 md2 offset-xs1>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Créditos"
                                                                            type="number"
                                                                            v-model="creditosMateria"
                                                                            :readonly="!bEditCourse"
                                                                            color="red darken-3"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>                                                                    
                                                                </v-layout>
                                                                

                                                                <v-layout row justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-textarea
                                                                            dense
                                                                            outlined
                                                                            v-model="descripcion"
                                                                            :auto-grow="false"
                                                                            no-resize
                                                                            color="red darken-2"
                                                                            label="Descripción"
                                                                            rows="5"
                                                                            :readonly="!bEditCourse"
                                                                        ></v-textarea>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-card>
                                                                            <v-toolbar height="20" color="red lighten-3" flat>
                                                                                <v-toolbar-title class="my-list-subtitle">Prerrequisitos</v-toolbar-title>
                                                                                <v-spacer></v-spacer>
                                                                                <v-menu offset-y>
                                                                                    <template v-slot:activator="{
                                                                                        on,}"
                                                                                    >
                                                                                        <v-btn x-small icon v-on="on" :disabled="!bEditCourse">
                                                                                            <v-icon>mdi-dots-vertical</v-icon>
                                                                                        </v-btn>
                                                                                    </template>
                                                                                    <v-list color="pink lighten-5">
                                                                                        <v-list-item @click="onAddPrereq">
                                                                                            <v-list-item-title>
                                                                                                <v-icon color="red darken-3">mdi-plus</v-icon>
                                                                                                    &nbsp;Agregar Prerrequisito
                                                                                            </v-list-item-title>
                                                                                        </v-list-item>
                                                                                        <v-list-item @click="onDeletePrereq" :disabled="prerreqID === 0">
                                                                                            <v-list-item-title>
                                                                                                <v-icon color="red darken-3" :disabled="prerreqID === 0">mdi-delete</v-icon>
                                                                                                    &nbsp;Borrar Prerrequisito
                                                                                            </v-list-item-title>
                                                                                        </v-list-item>
                                                                                    </v-list>
                                                                                </v-menu>
                                                                            </v-toolbar>

                                                                            <v-list
                                                                                subheader
                                                                                dense
                                                                                :height="prerreqListHeight"
                                                                                max-height="100%"
                                                                                class="overflow-y-auto"
                                                                                color="grey lighten-3"
                                                                                :disabled="loadingData"
                                                                            >
                                                                                <v-list-item-group
                                                                                    v-model="selectedPrerreqIndex"
                                                                                    color="red darden-3"
                                                                                    :mandatory="!bNewPlan"
                                                                                >
                                                                                    <v-list-item
                                                                                        class="my-list-item"
                                                                                        v-for="(prerreq, i) in prerrequisitos"
                                                                                        :key="i"
                                                                                        @click="selectPrereq(prerreq.materiaid)"
                                                                                    >
                                                                                        <v-list-item-content>
                                                                                            <v-list-item-title>
                                                                                                <v-container pa-0 fluid>
                                                                                                    <v-layout row wrap>
                                                                                                        <v-flex
                                                                                                            md2
                                                                                                            xs6
                                                                                                        >{{ prerreq.clave }} - {{ prerreq.materia }}</v-flex>
                                                                                                    </v-layout>
                                                                                                </v-container>
                                                                                            </v-list-item-title>
                                                                                        </v-list-item-content>
                                                                                    </v-list-item>
                                                                                </v-list-item-group>
                                                                            </v-list>
                                                                        </v-card>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>
                                                        
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout
                                                v-if="bEditCourse"
                                                align-center
                                                justify-end
                                                row
                                                fill-height
                                            >
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSaveCourse"
                                                        :disabled="!bEditCourse"
                                                    >Guardar Materia</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancelEditCourse"
                                                        :disabled="!bEditCourse"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de materia seleccionada *********************** -->
                        </v-layout>

                        <!-- Modal para cargar archivo de foto de paquete: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bChangePackageImgDlg" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="red darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Foto para el paquete</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-cloud-upload</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-file-input
                                                        color="red darken-2"
                                                        accept="image/*"
                                                        show-size
                                                        label="Archivo de imagen"
                                                        v-model="photoFile"
                                                    >Foto del paquete</v-file-input>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onChangePhotoFile"
                                        >OK</v-btn>

                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelChangePhotoFile"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para cargar archivo de foto de paquete *************************** -->

                        <!-- Modal para informar que se debe seleccionar un archivo para la foto del paquete: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bShowNullPhotoAlert"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="teal" dark flat>
                                        <v-toolbar-title class="my-list-title">Foto del Paquete</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >Debe seleccionar un archivo de imagen para la foto del paquete.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNullPhotoAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para informar que se debe seleccionar un archivo para la foto del paquete *********************************** -->

                        <!-- Modal para confirmar borrado de foto de paquete: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletePackageImgDlg" persistent max-width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Foto del Paquete</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>&nbsp; ¿Desea borrar la foto del paquete?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deletePackageImageConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeletePackageImg"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de foto de paquete *************************** -->

                        <!-- Modal para confirmar borrado de plan: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingPlan" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Plan</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar el plan {{ selectedPlanName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deletePlanConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeletePlan"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de plan *************************** -->

                        <!-- Modal para confirmar borrado de prerrequisito: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingPrereq" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Prerrequisito</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea quitar "{{ selectedPrereqName }}" como prerrequisito para esta materia?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="confirmDeletePrereq"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeletePrereq"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de prerrequisito *************************** -->

                        <!-- Modal para confirmar borrado de materia: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingCourse" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Materia</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar al plan {{ selectedCourseName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteCourseConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteCourse"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de materia *************************** -->

                        <!-- Modal para confirmar borrado de paquete: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingPackage" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar Paquete</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar al paquete {{ packageName }}?
                                    </v-card-title>
                                    <v-card-text
                                        class="text-center"
                                    >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deletePackageConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeletePackage"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de paquete *************************** -->

                        <!-- Modal para informar que no hubo resultados en la búsqueda: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bShowNotFoundAlert" persistent max-width="30%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Búsqueda de Materias</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >No se encontró ninguna materia con ese parámetro.</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bShowNotFoundAlert = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para informar que no hubo resultados en la búsqueda *************************** -->

                        
                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="red darken-3" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Información Incompleta</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidData = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->

                        <!-- Modal para agregar un prerrequisito: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgAddPrereq"
                                persistent
                                max-width="80%"
                            >
                                <v-card class="grey lighten-2">
                                    <v-toolbar dense color="red darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title"><v-icon>mdi-bookmark-check</v-icon> &nbsp; Agregar prerrequisito &nbsp;</v-toolbar-title>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container grid-list-sm fluid>
                                            <v-layout row wrap justify-space-around>
                                                <!-- Lista de materias: *************************** -->
                                                <v-flex xs10 sm5>
                                                    <v-card>
                                                        <v-toolbar height="40" dense color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-title">Materias &nbsp;</v-toolbar-title>
                                                            <v-text-field
                                                                hide-details
                                                                single-line
                                                                v-model="searchText"
                                                                dense
                                                            ></v-text-field>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-btn small icon @click="onSearchNoPrerreq" v-on="on">
                                                                        <v-icon>mdi-magnify</v-icon>
                                                                    </v-btn>
                                                                </template>
                                                                <span>Buscar por nombre o clave</span>
                                                            </v-tooltip>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-format-list-bulleted</v-icon>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="noPrerreqlistHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                            :disabled="loadingData"
                                                        >
                                                            <v-list-item-group
                                                                v-model="selectedNoPrerreqIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(course, i) in noPrerrequisitos"
                                                                    :key="i"
                                                                    @click="selectNoPrerreq(course.materiaid)"
                                                                    :id="-course.materiaid"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{  course.clave + " - " + course.materia }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <!-- Termna lista de materias ***************************************** -->
                                                <!-- Info de materia seleccionada ************************************* -->
                                                <v-flex xs10 sm7>
                                                    <v-card class="grey lighten-4">
                                                        <v-toolbar height="40" color="red lighten-2" flat>
                                                            <v-toolbar-title class="my-list-title">{{ selectedNoPrereqName }}</v-toolbar-title>
                                                        </v-toolbar>

                                                        <v-card-text>
                                                            <v-container fluid>
                                                                <v-layout wrap justify-space-between>
                                                                    <v-flex xs12>
                                                                        <v-text-field
                                                                            dense
                                                                            name="nombreMateria"
                                                                            label="Nombre de la materia"
                                                                            type="text"
                                                                            v-model="nombrePrerreq"
                                                                            readonly
                                                                            color="red darken-3"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row justify-space-between>
                                                                    <v-flex xs6 sm3 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Clave"
                                                                            type="text"
                                                                            v-model="clavePrerreq"
                                                                            readonly
                                                                            color="red darken-3"
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                    <v-flex xs4 md2>
                                                                        <v-text-field
                                                                            dense
                                                                            label="Créditos"
                                                                            type="number"
                                                                            v-model="creditosPrerreq"
                                                                            readonly
                                                                            color="red darken-3"
                                                                            reverse
                                                                        ></v-text-field>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>

                                                    </v-card>
                                                </v-flex>
                                                <!-- Termina info de materia seleccionada ***************************** -->
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="confirmAddPrereq"
                                        >Agregar prerrequisito</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelAddPrereq"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para agregar un prerrequisito ************************ -->

                        <!-- Modal para agregar un programa al paquete seleccionado: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgAddProgram"
                                persistent
                                max-width="80%"
                            >
                                <v-card class="grey lighten-2">
                                    <v-toolbar dense color="red darken-2" dark flat>
                                        <v-toolbar-title class="my-list-title"><v-icon>mdi-school</v-icon> &nbsp; Agregar programa al paquete
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn text @click="cancelAddProgram" v-on="on">
                                                    <v-icon>mdi-close</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Cancelar</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container grid-list-sm fluid>
                                            <v-layout wrap justify-space-around>
                                                <v-flex xs11 md6>
                                                    <v-card>
                                                        <v-toolbar height="30" color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">División</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-file-tree-outline</v-icon>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="divisionListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                        >
                                                            <v-list-item-group
                                                                v-model="addProgramSelectedDivisionIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(division, i) in addProgramDivisiones"
                                                                    :key="i"
                                                                    @click="addProgramSelectDivision(division.divisionid)"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ division.nombre }} - {{ division.sigla }} </v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs11 md6>
                                                    <v-card>
                                                        <v-toolbar height="30" color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">Departamento</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-home-outline</v-icon>
                                                        </v-toolbar>
                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="divisionListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                        >
                                                            <v-list-item-group
                                                                v-model="addProgramSelectedDepartmentIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(department, i) in addProgramDepartamentos"
                                                                    :key="i"
                                                                    @click="addProgramSelectDepartment(department.departamentoid)"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ department.nombre }}</v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                            <p></p>
                                            <v-layout wrap justify-space-around>
                                                <v-flex xs11 md6>
                                                    <v-card>
                                                        <v-toolbar height="30" color="red darken-2" dark flat>
                                                            <v-toolbar-title class="my-list-subtitle">Programa o Servicio Departamental</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-school</v-icon>
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            :height="divisionListHeight"
                                                            max-height="100%"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                        >
                                                            <v-list-item-group
                                                                v-model="addProgramSelectedProgramIndex"
                                                                color="orange accent-4"
                                                                mandatory
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(program, i) in addProgramProgramas"
                                                                    :key="i"
                                                                    @click="addProgramSelectProgram(program.programaid)"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row wrap>
                                                                                    <v-flex
                                                                                        md2
                                                                                        xs6
                                                                                    >{{ program.nombre }} </v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <v-flex xs11 md6>
                                                    <v-container fill-height fluid>
                                                        <v-layout align-end justify-end>
                                                            <v-flex shrink>
                                                                <v-btn
                                                                    color="teal darken-3"
                                                                    class="text-none"
                                                                    text
                                                                    @click="confirmAddProgram"
                                                                >Agregar programa</v-btn>
                                                                <v-btn
                                                                    color="pink darken-1"
                                                                    class="text-none"
                                                                    text
                                                                    @click="cancelAddProgram"
                                                                >Cancelar</v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>        
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para agregar un programa al paquete seleccionado ************************ -->

                        <!-- Modal para decir que no se puede agregar dos veces el mismo programa a un paquete: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidProgram" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="red darken-3" dark flat>
                                        <v-toolbar-title
                                            class="my-list-title"
                                        >Programa no válido</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-alert-circle-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                    >mdi-alert</v-icon>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center text-center"
                                                >{{ errorMessage }}</v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidProgram = false"
                                        >OK</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para decir que no se puede agregar dos veces el mismo programa a un paquete *********************************** -->

                        <!-- Modal para confirmar borrado de programa de un paquete: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bDeletingProgram" persistent width="35%">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title">Borrar programa de un paquete</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon large color="orange darken-2">mdi-alert</v-icon>
                                        </div>
                                        &nbsp; ¿Desea borrar el programa {{ selectedPackageProgramName }}?
                                    </v-card-title>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteProgramConfirmed"
                                        >OK</v-btn>
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteProgram"
                                        >Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de programa de un paquete *************************** -->
                        
                        <!-- Termina renglón único para lista de planes y plan seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de planes y plan seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'planes',
    data() {
        return {
            bDense: true,
            drawer: false,
            bMounted: false, //Para saber si ya se puede obtener la altura de los componentes.
            courseToolbarHeight: 40,
            planToolbarHeight: 48,
            
            bEditPlan: false,
            bEditCourse: false,
            bNewPlan: false,
            bNewCourse: false,
            bEditPackage: false,
            bNewPackage: false,

            
            mandatoryCourses: 0,
            optionalCourses: 0,
            
            bInvalidData: false,
            bInvalidProgram: false,
            errorMessage: '',

            planID: 0,

            divisionID: 0,
            departmentID: 0,
            programID: 0,
            packageID: 0,

            selectedDivisionIndex: 0,
            departamentos: [],
            selectedDepartmentIndex: -1,
            programas: [],
            selectedProgramIndex: -1,

            originalPackage: null, //Para poder regresar a los valores originales en caso de que se cancele una edición.
            packageName: '',
            packageDescription: '',
            packageNotes: '',
            packagePrograms: [],
            
            selectedOptName: '',
            nombrePlan: '',
            photoInfo: null, //Objeto regresado por el servidor con la información para reconstruir el archivo de la foto de un paquete.
            photoFile: null, //Archivo cargado por el file input, para agregar o cambiar la foto de un paquete.
            bPhoto: false,
            bShowNullPhotoAlert: false,
            bDeletePhoto: false, //Indica que al guardar el paquete se debe borrar su foto.
            bChangePackageImgDlg: false,
            bDeletePackageImgDlg: false,

            periodoInicioID: 0,
            seasons: [
                {
                    termID: 1,
                    term: 'Primavera'
                },
                {
                    termID: 2,
                    term: 'Verano'
                },
                {
                    termID: 3,
                    term: 'Otoño'
                }
            ],

            anioInicio: 0,
            
            
            bMenuDateIni: false,
            
            selectedPrerreqIndex: 0,
            selectedNoPrerreqIndex: 0,
            
            selectedPlanName: '',
            selectedCourseName: '',
            selectedPrereqName: '',

            nombreMateria: '',
            clave: '',
            creditosMateria: 0,
            
            descripcion: '',
            prerrequisitos: [],
            noPrerrequisitos: [], //Lista de materias que no son prerrequisitos de la materia seleccionada, y por lo tanto pueden aparecer en el modal para agregar un prerrequisito.


            bDeletingPlan: false,
            bDeletingPackage: false,
            bDeletingCourse: false,
            searchText: '',
            bShowNotFoundAlert: false, //Indica si se debe mostrar el diálogo que indica que no hubo resultados en la búsqueda.

            bDlgAddPrereq: false,
            prerreqID: 0,
            noPrerreqID: 0,
            selectedNoPrereqName: '',
            nombrePrerreq: '',
            clavePrerreq: '',
            
            creditosPrerreq: 0,

            
            bDeletingPrereq: false,
            bCourseEdited: false, //Evita que se seleccione automáticamente la primera materia de la lista cuando se edita o cuando se registra una materia.
            bPackageEdited: false, //Evita que se seleccione automáticamente el primer paquete de la lista cuando se edita o cuando se registra un paquete.

            selectedPackageProgramIndex: -1,
            selectedPackageProgramID: 0,
            selectedPackageProgramName: "",
            bDlgAddProgram: false,
            addProgramSelectedDivisionIndex: 0,
            addProgramSelectedDepartmentIndex: 0,
            addProgramSelectedProgramIndex: 0,
            addProgramDivisionID: 0,
            addProgramDepartmentID: 0,
            addProgramProgramID: 0,
            addProgramProgramName: '',
            addProgramDivisiones: [],
            addProgramDepartamentos: [],
            addProgramProgramas: [],
            bDeletingProgram: false,
            programsToAdd: [], //Programas de un paquete a agregar si se guardan los cambios un paqueete en edición.
            programsToDelete: [], //Programas de un paquete a borrar si se guardan los cambios de un paquete en edición.
            
        };
    },
    created() {
        
        this.materiasPaqueteLoaded = false;
        this.selectFirstPlan();
        this.selectFirstDivision();
        
    },

    mounted() {
        //console.log("mounted(), this.$refs.course_card.$e1.clientHeight = ", this.$refs.course_card.$el.clientHeight);
        //console.log("mounted(), this.$refs.plan_card.$e1.clientHeight = ", this.$refs.plan_card.$el.clientHeight);
        this.bMounted = true;
    },
    
    
    methods: {
        onClose() {
            this.$router.push('/');
        },

        selectFirstDivision()
        {
            if (this.divisiones.length > 0)
            {
                this.selectedDivisionIndex = 0;
                var divisionID = this.divisiones[this.selectedDivisionIndex].divisionid;
                this.selectDivision(divisionID);
            }
            else
            {
                this.selectedDivisionIndex = -1;
                this.divisionID = 0;
            }
        },

        selectDivision(divisionID)
        {
            this.divisionID = divisionID;
            this.selectedDivisionIndex = 0;
            
            for (let i = 0; i < this.divisiones.length; i ++)
            {
                if (this.divisiones[i].divisionid === this.divisionID)
                {
                    this.selectedDivisionIndex = i;

                    this.departamentos = this.divisiones[i].departamentos;
                    this.programas = [];
                    this.selectFirstDepartment();
                    
                    break;
                }
            }
        },

        selectFirstDepartment()
        {
            if (this.departamentos.length > 0)
            {
                this.selectedDepartmentIndex = 0;
                var departmentID = this.departamentos[this.selectedDepartmentIndex].departamentoid;
                this.selectDepartment(departmentID);
            }
            else
            {
                this.selectedDepartmentIndex = -1;
                this.departmentID = 0;
                this.programas = [];
                this.selectedProgramIndex = -1;
                this.programID = 0;

                this.initCourseFields();

            }
        },

        initCourseFields()
        {
            this.materiasPaquete = [];
            this.nombreMateria = "";
            this.clave = "";
            this.creditosMateria = 0;
            this.descripcion = "";
            this.prerreqID = 0;
            this.selectedPrereqName = "",
            this.prerrequisitos = [];
            this.selectedCourseName = "";
        },

        selectDepartment(departmentID)
        {
            this.departmentID = departmentID;

            for (let i = 0; i < this.departamentos.length; i ++)
            {
                if (this.departamentos[i].departamentoid === departmentID)
                {
                    this.programas = this.departamentos[i].programas;
                    this.selectFirstProgram();
                    break;
                }
            }
        },

        selectFirstProgram()
        {
            if (this.programas.length > 0)
            {
                this.selectedProgramIndex = 0;
                var programID = this.programas[this.selectedProgramIndex].programaid;
                this.selectProgram(programID);
            }
            else
            {
                this.paquetesPrograma = [];
                this.packageID = 0;
                this.packageName = "";
                this.packageDescription = "";
                this.packageNotes = "";
                this.packagePrograms = [];
                this.photoInfo = null;        
                this.bPhoto = false;
                this.packageImg = require('@/assets/no-photo.png');
                this.selectedProgramIndex = -1;
                this.programID = 0;

                this.initCourseFields();
            }
        },

        selectProgram(programID)
        {
            this.programID = programID;
            this.paquetesPrograma = [];
            this.packageID = 0;
            this.packageName = "";
            this.packageDescription = "";
            this.packageNotes = "";
            this.packagePrograms = [];
            this.photoInfo = null;        
            this.bPhoto = false;
            this.packageImg = require('@/assets/no-photo.png');

            this.initCourseFields();

            var packagesInfo = {
                planid: this.planID,
                programaid: this.programID
            }

            this.$store.dispatch('fetchPaquetesPrograma', packagesInfo)
            //console.log("paquetesPrograma  = ", this.paquetesPrograma);
        },

        selectFirstPackage()
        {
            if (this.paquetesPrograma.length > 0)
            {
                this.selectedPaqueteIndex = 0;
                var packageID = this.paquetesPrograma[this.selectedPaqueteIndex].paqueteid;
                this.selectPackage(packageID);
            }
            else
            {
                this.selectedPaqueteIndex = -1;
                this.packageID = 0;
                this.materiaID = 0;
                this.nombreMateria = '';
                this.clave = '';
                this.descripcion = '';
                this.creditosMateria = 0;
                this.prerrequisitos = [];
                this.selectedCourseName = '';
                this.selectedPackageProgramID = 0;

                this.initCourseFields();
            }
        },

        selectPackage(packageID)
        {
            this.materiaID = 0;
            this.nombreMateria = '';
            this.clave = '';
            this.descripcion = '';
            this.creditosMateria = 0;
            this.prerrequisitos = [];
            this.selectedCourseName = '';

            this.initCourseFields();

            this.packageID = packageID;

            for (let i = 0; i < this.paquetesPrograma.length; i ++)
            {
                if (this.paquetesPrograma[i].paqueteid === packageID)
                {
                    this.packageName = this.paquetesPrograma[i].nombre;
                    this.packageDescription = this.paquetesPrograma[i].descripcion;
                    this.packageNotes = this.paquetesPrograma[i].notas;
                    this.packagePrograms = this.paquetesPrograma[i].programas;
                    this.selectedPackageProgramIndex = 0;
                    this.selectedPackageProgramID = this.packagePrograms[0].programaid;

                    this.photoInfo = this.paquetesPrograma[i].logoInfo;
                    if (this.photoInfo.id === null)
                    {
                        this.bPhoto = false;
                        this.packageImg = require('@/assets/no-photo.png');
                    }
                    else
                    {
                        this.bPhoto = true;
                        this.$store.dispatch('getFotoPaquete', this.photoInfo);
                    }

                    break;
                }
            }

            this.$store.dispatch('fetchMateriasPaquete', this.packageID)
            //console.log("paquetesPrograma  = ", this.paquetesPrograma);
            
        },
        

        onNewPlan() {
            this.bEditPlan = true;
            this.bNewPlan = true;
            this.selectedPlanIndex = -1;

            this.planID = 0;
            this.nombrePlan = '';
            this.periodoInicioID = 0;
            this.anioInicio = 0;
            
            this.selectedPlanName = 'Nuevo Plan';

            this.materiaID = 0;
            this.nombreMateria = '';
            this.clave = '';
            
            this.creditosMateria = 0;
            
            this.descripcion = '';
            this.prerrequisitos = [];
            this.selectedCourseName = '';

            this.$refs.plan_name_field.focus();
            
        },
        onDeletePlan() {
            this.bDeletingPlan = true;
        },
        cancelDeletePlan() {
            this.bDeletingPlan = false;
        },
        deletePlanConfirmed() {
            this.bDeletingPlan = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.planesEstudios.length; i++)
            {
                if (this.planesEstudios[i].planid === this.planID)
                {
                    this.planesEstudios.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deletePlan', this.planID);
            this.selectFirstPlan();
        },

        onEditPlan() {
            this.bEditPlan = true;
        },
        
        onCancelEditPlan() {
            if (this.bNewPlan) {
                //Selecciona al primer plan de la lista:
                this.selectFirstPlan();
                this.bNewPlan = false;
            } else {
                //Vuelve a obtener los datos originales del plan seleccionado:
                this.selectPlan(this.planID);
            }
            this.bEditPlan = false;
        },

        onSavePlan()
        {
            this.bInvalidData = false;

            //Se validan los datos:

            if (this.nombrePlan === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Escriba el nombre del plan de estudios.';
            }
            else
            if (this.periodoInicioID === 0)
            {
                this.bInvalidData = true;
                this.errorMessage = 'Introduzca el periododo de inicio del plan de estudios.';
            }
            else
            if ((this.anioInicio < 2000) || (this.anioInicio > 3000))
            {
                this.bInvalidData = true;
                this.errorMessage = 'Introduzca un año de inicio válido para el plan de estudios.';
            }
            else
            {
                //Checa si hay otro plan con el mismo nombre:
                for (let i = 0; i < this.planesEstudios.length; i ++)
                {
                    //Si se está editando el plan, se salta el plan en edición (si es un plan nuevo planID = 0):
                    if (this.planesEstudios[i].planid === this.planID)
                    {
                        continue;
                    }
                    else
                    if (this.planesEstudios[i].plan === this.nombrePlan)
                    {
                        //console.log("Plan igual encontrado...");
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otro plan con el mismo nombre.";
                        break;
                    }
                }
            }

            if (!this.bNewPlan && !this.bInvalidData)
            {
                //Edición de plan de estudios...

                const planInfo = {
                    planid: this.planID,
                    nombrePlan: this.nombrePlan,
                    anioInicio: this.anioInicio,
                    periodoInicioid: this.periodoInicioID,

                };
                //console.log('planInfo = ', planInfo);

                this.$store.dispatch('editPlan', planInfo);

            } //end edición de plan.
            else if (this.bNewPlan && !this.bInvalidData)
            {
                //Registro de nuevo plan...

                this.bNewPlan = false;

                const newPlan = {
                    planid: this.planID,
                    nombrePlan: this.nombrePlan,
                    anioInicio: this.anioInicio,
                    periodoInicioid: this.periodoInicioID,
                };

                this.$store.dispatch('saveNewPlan', newPlan);
                
            } //end registro de nuevo plan.

            if (!this.bInvalidData)
            {
                this.selectedPlanName = this.nombrePlan;
                this.bEditPlan = false;
            }
        },

        selectFirstPlan()
        {
            if (this.planesEstudios.length > 0)
            {
                this.selectedPlanIndex = 0;
                var planID = this.planesEstudios[this.selectedPlanIndex].planid;
                this.selectPlan(planID);
            }
            else
            {
                this.selectedPlanIndex = -1;
                this.planID = 0;
            }
        },

        selectPlan(planID)
        {
            this.planID = planID;

            for (let i = 0; i < this.planesEstudios.length; i ++)
            {
                if (this.planesEstudios[i].planid === planID)
                {
                    this.nombrePlan = this.planesEstudios[i].plan;
                    this.anioInicio = this.planesEstudios[i].anioInicio;
                    this.periodoInicioID = this.planesEstudios[i].periodoInicioid;
                }
            }
            
            this.materiaID = 0;
            this.nombreMateria = '';
            this.clave = '';
            
            this.creditosMateria = 0;
            

            this.descripcion = '';
            this.prerrequisitos = [],
            this.selectedCourseName = '';

            //Pendiente: originalmente loadingData estaba abajo en true. Checar cómo se va a dejar aquí:
            this.loadingData = false; //Para no dejar seleccionar otro plan antes de que se haya terminado de cargar toda la información.
            this.planID = planID;
            
        },

        onNewPackage(){
            this.bEditPackage = true;
            this.bNewPackage = true;

            this.packageID = 0;
            this.packageName = '';
            this.packageDescription = '';
            this.packageNotes = "";
            this.packageImg = require('@/assets/no-photo.png');
            this.bPhoto = false;

            //Obtiene el nombre del programa seleccionado:
            var strPrograma = "";

            for (let i = 0; i < this.programas.length; i ++)
            {
                if (this.programas[i].programaid === this.programID)
                {
                    strPrograma = this.programas[i].nombre;
                    break;
                }
            }

            this.packagePrograms = [];
            const programToAdd = {
                departamentoid: 0,
                nombre: strPrograma,
                programaid: this.programID,
            }
            
            this.packagePrograms.push(programToAdd);

            this.programsToAdd = [];
            this.programsToAdd.push(this.programID);

            this.$refs.package_name_field.focus();

            //console.log("programsToAdd = ", this.programsToAdd);
        },

        onEditPackage(){
            //console.log("packageID = ", this.packageID);
            this.bEditPackage = true;
            this.programsToDelete = [];
            this.programsToAdd = [];

            //Se guardan los valores originales en originalPackage en caso de que se
            //cancele la edición:
            for (let i = 0; i < this.paquetesPrograma.length; i ++)
            {
                if (this.paquetesPrograma[i].paqueteid === this.packageID)
                {
                    this.originalPackage = JSON.parse(JSON.stringify(this.paquetesPrograma[i]));
                    break;
                }
            }

            //console.log("originalPackage = ", this.originalPackage);

            this.$refs.package_name_field.focus();
        },

        onSavePackage(){
            this.bInvalidData = false;

            if (this.packageName === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Escriba el nombre del paquete.';
            }
            else
            if (this.packageDescription === '')
            {
                this.bInvalidData = true;
                this.errorMessage = 'Escriba la descripción del paquete.';
            }
            else
            {
                //Checa si no hay otro paquete con el mismo nombre:
                for (let i = 0; i < this.paquetesPrograma.length; i ++)
                {
                    //Si se está editando el paquete, se salta el paquete en edición ( si es un paquete nuevo packageID = 0):
                    if (this.paquetesPrograma[i].paqueteid === this.packageID)
                    {
                        continue;
                    }
                    else
                    if (this.paquetesPrograma[i].nombre === this.packageName)
                    {
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otro paquete con el mismo nombre.";
                        break;
                    }
                }
            }

            if (!this.bNewPackage && !this.bInvalidData)
            {
                //Edición de paquete...

                const packageInfo = {
                    paqueteid: this.packageID,
                    nombre: this.packageName,
                    descripcion: this.packageDescription,
                    plan: this.nombrePlan,
                    planid: this.planID,
                    notas: this.packageNotes,
                    logoInfo: null,
                };

                var programasParaAgregar = [];
                for (let i = 0; i < this.programsToAdd.length; i ++)
                {
                    var programa = {
                        programaid: this.programsToAdd[i],
                    }
                    programasParaAgregar.push(programa);
                }

                var programasParaBorrar = [];
                for (let i = 0; i < this.programsToDelete.length; i ++)
                {
                    var programa = {
                        programaid: this.programsToDelete[i],
                    }
                    programasParaBorrar.push(programa);
                }

                var packageToUpdate = {
                    package: packageInfo,
                    photoFile: null,
                    deleteImage: false,
                    planid: this.planID,
                    programaid: this.programID,
                    programasParaAgregar: programasParaAgregar,
                    programasParaBorrar: programasParaBorrar,
                };

                if (this.bPhoto && this.photoFile !== null)
                {
                    packageToUpdate.photoFile = this.photoFile;
                }
                else
                if (this.bDeletePhoto)
                {
                    packageToUpdate.deleteImage = true;
                }

                //console.log("packageToUpdate = ", packageToUpdate);

                this.bPackageEdited = true; //Para evitar que se seleccione automáticamente el primer paquete de la lista.
                this.$store.dispatch('updatePackage', packageToUpdate);
            }
            else
            if (this.bNewPackage && !this.bInvalidData)
            {
                //Registro de nuevo paquete...

                const newPackage = {
                    paqueteid: 0,
                    nombre: this.packageName,
                    descripcion: this.packageDescription,
                    plan: this.nombrePlan,
                    planid: this.planID,
                    notas: this.packageNotes,
                    logoInfo: null,
                };

                var programasParaAgregar = [];
                for (let i = 0; i < this.programsToAdd.length; i ++)
                {
                    var programa = {
                        programaid: this.programsToAdd[i],
                    }
                    programasParaAgregar.push(programa);
                }

                var packageToSave = {
                    package: newPackage,
                    photoFile: null,
                    deleteImage: false,
                    planid: this.planID,
                    programas: programasParaAgregar,
                };

                if (this.bPhoto && this.photoFile !== null)
                {
                    packageToSave.photoFile = this.photoFile;
                }
                //console.log("packageToSave = ", packageToSave);

                this.$store.dispatch('saveNewPackage', packageToSave);
            }// end registro de nuevo paquete.

            if (!this.bInvalidData)
            {
                this.bEditPackage = false;
                this.bNewPackage = false;
            }
        },

        onCancelEditPackage()
        {
            if (!this.bNewPackage)
            {
                this.packageName = this.originalPackage.nombre;
                this.packageDescription = this.originalPackage.descripcion;
                this.packageNotes = this.originalPackage.notas;
                this.packagePrograms = this.originalPackage.programas;
                this.selectedPackageProgramIndex = 0;
                this.selectedPackageProgramID = this.packagePrograms[0].programaid;

                this.photoInfo = this.originalPackage.logoInfo;
                if (this.photoInfo.id === null)
                {
                    this.bPhoto = false;
                    this.packageImg = require('@/assets/no-photo.png');
                }
                else
                {
                    this.bPhoto = true;
                    this.$store.dispatch('getFotoPaquete', this.photoInfo);
                }
            }
            else
            {
                this.selectFirstPackage();
            }

            this.bEditPackage = false;
            this.bNewPackage = false;
            this.programsToDelete = [];
            this.programsToAdd = [];
        },

        onDeletePackage(){
            this.bDeletingPackage = true;
        },

        cancelDeletePackage(){
            this.bDeletingPackage = false;
        },

        deletePackageConfirmed(){
            this.bDeletingPackage = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            for (let i = 0; i < this.paquetesPrograma.length; i++)
            {
                if (this.paquetesPrograma[i].paqueteid === this.packageID)
                {
                    this.paquetesPrograma.splice(i, 1);
                    break;
                }
            }

            const packageInfo = {
                paqueteid: this.packageID,
                programaid: this.programID,
                planid: this.planID,
            }

            this.$store.dispatch('deletePackage', packageInfo);
            this.selectFirstPackage();
        },

        onChangePackageImg()
        {
            this.bChangePackageImgDlg = true;
        },

        onDeletePackageImg()
        {
            this.bDeletePackageImgDlg = true;
        },

        cancelDeletePackageImg()
        {
            this.bDeletePackageImgDlg = false;
        },

        deletePackageImageConfirmed()
        {
            this.bDeletePackageImgDlg = false;
            this.bPhoto = false;
            this.bDeletePhoto = true;
            this.packageImg = require('@/assets/no-photo.png');
        },

        onChangePhotoFile()
        {
            if (this.photoFile === null)
            {
                this.bShowNullPhotoAlert = true;
            }
            else
            {
                this.bChangePackageImgDlg = false;
                //console.log("photoFile = ", this.photoFile);
                var imageFileURL = URL.createObjectURL(this.photoFile);

                this.packageImg = imageFileURL;
                this.bPhoto = true;
                this.bDeletePhoto = false;
                //console.log('onChangePhotoFile, packageImg = ', this.packageImg);
            }
        },

        onCancelChangePhotoFile()
        {
            this.bChangePackageImgDlg = false;
        },

        selectFirstCourse()
        {
            //console.log("SelectFirstCourse...");
            if (this.materiasPaquete.length > 0)
            {
                this.selectedCourseIndex = 0;
                var materiaID = this.materiasPaquete[this.selectedCourseIndex].materiaid;
                this.selectCourse(materiaID);
            }
            else
            {
                this.selectedCourseIndex = -1;
                this.materiaID = 0;
            }
        },

        selectCourse(materiaID)
        {
            this.materiaID = materiaID;
            this.$store.dispatch('getMateria', materiaID);
        },

        selectFirstNoPrerreq()
        {
            if (this.noPrerrequisitos.length > 0)
            {
                this.selectedNoPrerreqIndex = 0;
                var materiaID = this.noPrerrequisitos[this.selectedNoPrerreqIndex].materiaid;
                this.selectNoPrerreq(materiaID);
            }
            else
            {
                this.selectedNoPrerreqIndex = -1;
                this.noPrerreqID = 0;
            }
        },

        selectNoPrerreq(materiaID)
        {
            this.noPrerreqID = materiaID;
            this.$store.dispatch('getNoPrerreq', materiaID);
        },

        onNewCourse(){
            this.bEditCourse = true;
            this.bNewCourse = true;
            this.selectedCourseIndex = -1;

            this.materiaID = 0;
            this.nombreMateria = '';
            this.clave = '';
            this.descripcion = '';
            this.creditosMateria = 0;
            this.prerrequisitos = [];

            this.selectedCourseName = '';

            this.$refs.materia_name_field.focus();
            
        },

        onEditCourse(){
            this.bEditCourse = true;
        },

        onDeleteCourse(){
            this.bDeletingCourse = true;
        },

        cancelDeleteCourse(){
            this.bDeletingCourse = false;
        },

        deleteCourseConfirmed(){
            this.bDeletingCourse = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            for (let i = 0; i < this.materiasPaquete.length; i++)
            {
                if (this.materiasPaquete[i].materiaid === this.materiaID)
                {
                    this.materiasPaquete.splice(i, 1);
                    break;
                }
            }

            const courseInfo = {
                materiaID: this.materiaID,
                paqueteID: this.packageID
            }

            this.$store.dispatch('deleteCourse', courseInfo);
            this.selectFirstPlan();
        },

        onAddPrereq(){
            //Crea el arreglo de materias disponibles para ser prerrequisitos:
            this.createNoPrerreq();

            this.selectFirstNoPrerreq();
            this.bDlgAddPrereq = true;
        },

        cancelAddPrereq(){
            this.bDlgAddPrereq = false;
        },

        confirmAddPrereq() {
            var newPrerreq = {
                materiaid: this.noPrerreqID,
                materia: this.nombrePrerreq,
                clave: this.clavePrerreq
            }
            this.prerrequisitos.push(newPrerreq);

            //console.log("newPrerreq = ", newPrerreq);

            //Selecciona al prerrequisito agregado:
            for (let i = 0; i < this.prerrequisitos.length; i ++)
            {
                if (this.prerrequisitos[i].materiaid === this.noPrerreqID)
                {
                    this.selectedPrerreqIndex = i;
                    this.selectPrereq(this.prerrequisitos[i].materiaid)
                    break;
                }
            }
            this.bDlgAddPrereq = false;
        },

        selectFirstPrereq(){
            if (this.prerrequisitos.length > 0)
            {
                this.selectedPrerreqIndex = 0;
                var prerreqID = this.prerrequisitos[this.selectedPrerreqIndex].materiaid;
                this.selectPrereq(prerreqID);
            }
            else
            {
                this.prerreqID = 0;
                this.selectedPrereqName = "";
            }
        },

        selectPrereq(materiaID){
            this.prerreqID = materiaID;
            for (let i = 0; i < this.prerrequisitos.length; i ++)
            {
                if (this.prerrequisitos[i].materiaid === materiaID)
                {
                    this.selectedPrereqName = this.prerrequisitos[i].materia;
                    //console.log("selectedPrereqName = ", this.selectedPrereqName);
                    break;
                }
            }
        },

        onDeletePrereq(){
            if (this.prerreqID !== 0)
            {
                this.bDeletingPrereq = true;
            }
        },

        cancelDeletePrereq(){
            this.bDeletingPrereq = false;
        },

        confirmDeletePrereq(){
            for (let i = 0; i < this.prerrequisitos.length; i ++)
            {
                if (this.prerrequisitos[i].materiaid === this.prerreqID)
                {
                    this.prerrequisitos.splice(i, 1);
                    break;
                }
            }

            this.bDeletingPrereq = false;
            this.selectFirstPrereq();
        },        

        onSaveCourse(){
            this.bInvalidData = false;

            //Se validan los datos:

            if (this.nombreMateria === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee el nombre de la materia.";
            }
            else
            if (this.clave === '')
            {
                this.bInvalidData = true;
                this.errorMessage = "Teclee la clave de la materia.";
            }
            else
            if (this.creditosMateria < 1)
            {
                this.bInvalidData = true;
                this.errorMessage = "Introduzca un número de créditos válido.";
            }
            else
            {
               //Checa si hay otra materia con los mismos datos:
               for (let i = 0; i < this.materiasPaquete.length; i ++)
               {
                   //Si se está editando la materia, se salta la materia en edición (si es un materia nueva materiaID = 0):
                   if (this.materiasPaquete[i].materiaid === this.materiaID)
                   {
                       continue;
                   }
                   else
                   if (this.materiasPaquete[i].materia === this.nombreMateria)
                   {
                       this.bInvalidData = true;
                       this.errorMessage = "Ya existe otra materia con el mismo nombre.";
                       break;
                   }
                   else
                   if (this.materiasPaquete[i].clave === this.clave)
                   {
                        this.bInvalidData = true;
                        this.errorMessage = "Ya existe otra materia con la misma clave.";
                        break;
                   }
               }
            }
            if ( !this.bInvalidData)
            {
                const courseInfo = {
                    materiaid: this.materiaID,
                    materia: this.nombreMateria,
                    clave: this.clave,
                    descripcion: this.descripcion,
                    creditos: Number(this.creditosMateria),
                    paqueteid: this.packageID,
                    prerrequisitos: this.prerrequisitos,
                }
                //console.log("onSaveCourse, courseInfo = ", courseInfo);

                this.bCourseEdited = true; //Para que cuando la lista de materias se refresque no se seleccione automáticamente la primera.

                if (!this.bNewCourse) //Edición de materia...
                {
                    this.$store.dispatch('editCourse', courseInfo);
                }
                else
                if (this.bNewCourse) //Registro de nueva materia...
                {
                    this.bNewCourse = false;
                    //console.log("Course to save = ", courseInfo);
                    this.$store.dispatch('saveNewCourse', courseInfo);
                }

                this.selectedCourseName = this.nombreMateria;
                this.bEditCourse = false;
            }
        },

        onCancelEditCourse(){
            if (this.bNewCourse)
            {
                //Selecciona la primera materia de la lista:
                this.selectFirstCourse();
                this.bNewCourse = false;
            }
            else
            {
                //Vuelve a obtener los datos originales de la materia seleccionada:
                this.selectCourse(this.materiaID);
            }
            this.bEditCourse = false;
            

        },

        selectPackageProgram(programID)
        {
            this.selectedPackageProgramID = programID;
            //console.log("selectedPackageProgramID = ", this.selectedPackageProgramID);
        },

        onAddProgram(){
            this.addProgramSelectedDivisionIndex = 0;
            this.addProgramSelectedDepartmentIndex = 0;
            this.addProgramSelectedProgramIndex = 0;
            this.addProgramDivisiones = JSON.parse(JSON.stringify(this.divisiones));

            this.addProgramSelectFirstDivision();

            this.bDlgAddProgram = true;
        },

        cancelAddProgram()
        {
            this.bDlgAddProgram = false;
        },

        confirmAddProgram(){
            this.bInvalidProgram = false;

            //Checa que el programa no haya sido agregado antes:
            for (let i = 0; i < this.packagePrograms.length; i ++)
            {
                if (this.addProgramProgramID === this.packagePrograms[i].programaid)
                {
                    this.bInvalidProgram = true;
                    this.errorMessage = "El paquete ya pertenece al programa o servicio departamental seleccionado.";
                    break;
                }
            }
            if (!this.bInvalidProgram)
            {
                const programToAdd = {
                    departamentoid: 0,
                    nombre: this.addProgramProgramName,
                    programaid: this.addProgramProgramID,
                }
                this.packagePrograms.push(programToAdd);
                this.programsToAdd.push(this.addProgramProgramID);

                //Busca si el programa se había querido borrar antes, y si es así lo quita del arreglo de programas por borrar:
                for (let i = 0; i < this.programsToDelete.length; i ++)
                {
                    if (this.programsToDelete[i] === this.addProgramProgramID)
                    {
                        this.programsToDelete.splice(i, 1);
                        break;
                    }
                }
                this.bDlgAddProgram = false;
            }
        },

        onDeleteProgram(){
            for (let i = 0; i < this.packagePrograms.length; i ++)
            {
                if (this.selectedPackageProgramID === this.packagePrograms[i].programaid)
                {
                    this.selectedPackageProgramName = this.packagePrograms[i].nombre;
                    this.programsToDelete.push(this.selectedPackageProgramID);
                    break;
                }
            }

            //Busca si el programa se había querido agregar antes, y si es así lo quita del arreglo de programas por agregar:
            for (let i = 0; i < this.programsToAdd.length; i ++)
                {
                    if (this.programsToAdd[i] === this.selectedPackageProgramID)
                    {
                        this.programsToAdd.splice(i, 1);
                        break;
                    }
                }

            this.bDeletingProgram = true;

        },

        cancelDeleteProgram()
        {
            this.bDeletingProgram = false;
        },

        deleteProgramConfirmed()
        {
            for (let i = 0; i < this.packagePrograms.length; i ++)
            {
                if (this.selectedPackageProgramID === this.packagePrograms[i].programaid)
                {
                    this.packagePrograms.splice(i, 1);
                    break;
                }
            }

            this.programsToDelete.push(this.selectedPackageProgramID);
            this.bDeletingProgram = false;
        },

        addProgramSelectFirstDivision()
        {
            if (this.addProgramDivisiones.length > 0)
            {
                this.addProgramSelectedDivisionIndex = 0;
                var divisionID = this.addProgramDivisiones[this.addProgramSelectedDivisionIndex].divisionid;
                this.addProgramSelectDivision(divisionID);
            }
            else
            {
                this.selectedDivisionIndex = -1;
                this.divisionID = 0;
            }
        },

        addProgramSelectDivision(divisionID)
        {
            //console.log("addProgramSelectDivision");
            this.addProgramDivisionID = divisionID;    
            this.addProgramSelectedDivisionIndex = 0;

            for (let i = 0; i < this.addProgramDivisiones.length; i ++)
            {
                if (this.addProgramDivisiones[i].divisionid === this.addProgramDivisionID)
                {
                    this.addProgramSelectedDivisionIndex = i;

                    this.addProgramDepartamentos = this.addProgramDivisiones[i].departamentos;
                    this.addProgramProgramas = [];
                    //console.log("addProgramDepartamentos = ", this.addProgramDepartamentos);
                    this.addProgramSelectFirstDepartment();

                    break;
                }
            }
        },

        addProgramSelectFirstDepartment()
        {
            //console.log("addProgramSelectFirstDepartment");
            if (this.addProgramDepartamentos.length > 0)
            {
                this.addProgramSelectedDepartmentIndex = 0;
                var departmentID = this.addProgramDepartamentos[this.addProgramSelectedDepartmentIndex].departamentoid;
                this.addProgramSelectDepartment(departmentID);
            }
            else
            {
                this.addProgramSelectedDivisionIndex = -1;
                this.addProgramDepartmentID = 0;
                this.addProgramProgramas = [];
                this.addProgramSelectedProgramIndex = -1;
                this.addProgramProgramID = 0;
                this.addProgramProgramName = "";
            }
        },

        addProgramSelectDepartment(departmentID)
        {
            this.addProgramDepartmentID = departmentID;

            for (let i = 0; i < this.addProgramDepartamentos.length; i ++)
            {
                if (this.addProgramDepartamentos[i].departamentoid === departmentID)
                {
                    this.addProgramProgramas = this.addProgramDepartamentos[i].programas;
                    this.addProgramSelectFirstProgram();
                    break;
                }
            }
        },

        addProgramSelectFirstProgram()
        {
            if (this.addProgramProgramas.length > 0)
            {
                this.addProgramSelectedProgramIndex = 0;
                var programID = this.addProgramProgramas[this.addProgramSelectedProgramIndex].programaid;
                this.addProgramSelectProgram(programID);
            }
            else
            {
                this.addProgramSelectedProgramIndex = -1;
                this.addProgramProgramID = 0;
                this.addProgramProgramName = "";
            }
        },

        addProgramSelectProgram(programID)
        {
            this.addProgramProgramID = programID;
            for (let i = 0; i < this.addProgramProgramas.length; i ++)
            {
                if (this.addProgramProgramas[i].programaid === programID)
                {
                    this.addProgramProgramName = this.addProgramProgramas[i].nombre;
                    break;
                }
            }
        },

        createNoPrerreq()
        {
            //Crea el arreglo de materias que pueden ser prerrequisitos de la materia seleccionada (pero aún no lo son):
            this.noPrerrequisitos = [];

            //console.log("materias = ", this.materiasPaquete);
            //console.log("materiaID = ", this.materiaID);

            for (let i = 0; i < this.materiasPaquete.length; i ++)
            {
                //Si la materia es la materia seleccionada, se salta:
                if (this.materiasPaquete[i].materiaid === this.materiaID)
                {
                    continue;
                }
                else
                //Se checa si la materia ya es prerrequisito:
                var alreadyPrereq = false;
                for (let j = 0; j < this.prerrequisitos.length; j ++)
                {
                    if (this.prerrequisitos[j].materiaid === this.materiasPaquete[i].materiaid){
                        alreadyPrereq = true;
                        break;
                    }
                    //Si llegamos a este punto, la materia ni es la seleccionada ni es prerrequisito, por lo que se agrega a la lista:
                }
                if (!alreadyPrereq)
                {
                    this.noPrerrequisitos.push(this.materiasPaquete[i]);
                }
            }
        },

        onSearchCourse()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var bFound = false;
                for (let i = 0; i < this.materiasPaquete.length; i++)
                {
                    let strLowerCaseMateria = this.materiasPaquete[i].materia.toLowerCase();
                    let strLowerCaseClave = this.materiasPaquete[i].clave.toLowerCase();
                    
                    if ((strLowerCaseMateria.indexOf(searchTextLowerCase) === 0) ||
                        (strLowerCaseClave.indexOf(searchTextLowerCase) === 0))
                    {
                        this.selectedCourseIndex = i;
                        this.scroll(this.materiaID);
                        this.selectCourse(this.materiasPaquete[i].materiaid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },

        onSearchNoPrerreq()
        {
            if (this.searchText != '')
            {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchText.toLowerCase();

                var bFound = false;
                for (let i = 0; i < this.noPrerrequisitos.length; i++)
                {
                    let strLowerCaseMateria = this.noPrerrequisitos[i].materia.toLowerCase();
                    let strLowerCaseClave = this.noPrerrequisitos[i].clave.toLowerCase();
                    
                    if ((strLowerCaseMateria.indexOf(searchTextLowerCase) === 0) ||
                        (strLowerCaseClave.indexOf(searchTextLowerCase) === 0))
                    {
                        this.selectedNoPrerreqIndex = i;
                        
                        this.selectNoPrerreq(this.noPrerrequisitos[i].materiaid);
                        this.scroll(-this.noPrerreqID);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound)
                {
                    this.bShowNotFoundAlert = true;
                }
                this.searchText = '';
            }
        },

        scroll(id)
        {
            //console.log("En scroll, id = ", id);
            if (document.getElementById(id) !== null)
            {
                document.getElementById(id).scrollIntoView({behavior: "smooth"});
            }
        }
    },
    computed:
    {
        ...mapGetters([
            'waitCursor',
            'divisiones'
        ]),

        selectedPlanIndex:
        {
            get() {
                return this.$store.getters.selectedPlanIndex;
            },
            set(selectedPlanIndex) {
                this.$store.dispatch( 'updateSelectedPlanIndex', selectedPlanIndex);
            },
        },

        selectedPaqueteIndex:
        {
           get() {
                return this.$store.getters.selectedPaqueteIndex;
            },
            set(selectedPaqueteIndex) {
                this.$store.dispatch( 'updateSelectedPaqueteIndex', selectedPaqueteIndex);
            },
        },

        selectedCourseIndex:
        {
           get() {
                return this.$store.getters.selectedCourseIndex;
            },
            set(selectedCourseIndex) {
                this.$store.dispatch( 'updateSelectedCourseIndex', selectedCourseIndex);
            },
        },

        planesEstudios: {
            get() {
                return this.$store.getters.planesEstudios;
            },
            set(planesEstudios) {
                this.$store.dispatch('updatePlanesEstudios', planesEstudios);
            },
        },

        planEstudios: {
            get() {
                return this.$store.getters.planEstudios;
            },
            set(planEstudios) {
                this.$store.dispatch('updatePlanEstudios', planEstudios);
            },
        },

        paquetesPrograma: {
            get() {
                return this.$store.getters.paquetesPrograma;
            },
            set(paquetesPrograma) {
                this.$store.dispatch('updatePaquetesPrograma', paquetesPrograma);
            },
        },

        materiasPaquete: {
            get() {
                return this.$store.getters.materiasPaquete;
            },
            set(materiasPaquete) {
                this.$store.dispatch('updateMateriasPaquete', materiasPaquete);
            },
        },

        materia: {
            get() {
                return this.$store.getters.materia;
            },
            set(materia) {
                this.$store.dispatch('updateMateria', materia);
            },
        },

        materiaID: {
            get() {
                return this.$store.getters.materiaID;
            },
            set(materiaID) {
                this.$store.dispatch('updateMateriaID', materiaID);
            },
        },

        noPrerreq: {
            get() {
                return this.$store.getters.noPrerreq;
            },
            set(noPrerreq) {
                this.$store.dispatch('updateNoPrerreq', noPrerreq);
            },
        },

        paquetesProgramaLoaded: {
            get() {
                return this.$store.getters.paquetesProgramaLoaded;
            },
            set(paquetesProgramaLoaded) {
                this.$store.dispatch('updatePaquetesProgramaLoaded', paquetesProgramaLoaded);
            },
        },

        materiasPaqueteLoaded: {
            get() {
                return this.$store.getters.materiasPaqueteLoaded;
            },
            set(materiasPaqueteLoaded) {
                this.$store.dispatch('updateMateriasPaqueteLoaded', materiasPaqueteLoaded);
            },
        },

        materiaLoaded: {
            get() {
                return this.$store.getters.materiaLoaded;
            },
            set(materiaLoaded) {
                this.$store.dispatch('updateMateriaLoaded', materiaLoaded);
            },
        },

        noPrerreqLoaded: {
            get() {
                return this.$store.getters.noPrerreqLoaded;
            },
            set(noPrerreqLoaded) {
                this.$store.dispatch('updateNoPrerreqLoaded', noPrerreqLoaded);
            },
        },

        loadingData: {
            get() {
                return this.$store.getters.loadingData;
            },
            set(loadingData) {
                this.$store.dispatch('updateLoadingData', loadingData);
            },
        },

        packageImg: {
            get() {
                return this.$store.getters.packageImg;
            },
            set(packageImg) {
                this.$store.dispatch('updatePackageImg', packageImg);
            }
        },

        planListHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '100px';
            }
            else
            if (this.$vuetify.breakpoint.sm) {
                height = '100px';
            }
            else
            if (this.bMounted)
            {
                height = this.$refs.plan_card.$el.clientHeight - this.planToolbarHeight + 'px';
                //height = this.$refs.plan_card.$el.clientHeight + 'px';
            }
            else
            {
                height = '100px';
            }
           
            return height;
        },

        divisionListHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '120px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '120px';
            } else {
                height = '120px';
            }
            return height;
        },

        courseListHeight() {
            var height;
            if (this.bMounted)
            {
                height = this.$refs.course_card.$el.clientHeight - this.courseToolbarHeight + 'px';
                //height = this.$refs.course_card.$el.clientHeight - 30 + 'px';
            }
            else
            {
                height = '100px';
            }
            // if (this.$vuetify.breakpoint.xs) {
            //     height = '100px';
            // } else if (this.$vuetify.breakpoint.sm) {
            //     height = '200px';
            // } else {
            //     //height = '400px';
            //     //height = this.$refs.course_card.clientHeight;
            //     //height = document.getElementById('course_card').clientHeight;
                
                
            // }
            return height;
        },

        noPrerreqlistHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '100px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '300px';
            } else {
                height = '500px';
            }
            return height;
        },

        prerreqListHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '60px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '100px';
            } else {
                height = '130px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        photoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '60';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '70';
            } else if (this.$vuetify.breakpoint.md) {
                height = '90';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '120';
            } else {
                height = '150';
            }
            return height;
        },
    },

    watch: {
        paquetesProgramaLoaded: function(value, oldValue)
        {
            if (this.paquetesProgramaLoaded)
            {
                //Si no se acaba de editar o registrar un paquete, se selecciona el primer paquete de la lista:
                if (!this.bPackageEdited)
                {
                    //console.log("PaquetesProgramaLoaded, seleccionar primer paquete...");
                    this.selectFirstPackage();
                    this.bPackageEdited = false;
                }
                this.bPackageEdited = false;

                this.paquetesProgramaLoaded = false;
            }
        },

        materiasPaqueteLoaded: function(value, oldValue)
        {
            //console.log("materiasPaqueteLoaded, planEstudios = ", this.planEstudios);
            if (this.materiasPaqueteLoaded)
            {
                //Si no se acaba de editar o registrar una materia, se selecciona la primera materia de la lista:
                if (!this.bCourseEdited)
                {
                    this.selectedPlanName = this.nombrePlan;
                    this.selectFirstCourse();
                    this.bCourseEdited = false;
                }

                this.materiasPaqueteLoaded = false;
            }
        },

        materiaLoaded: function(value, oldValue)
        {
            if (this.materiaLoaded)
            {
                this.nombreMateria = this.materia.materia;
                this.clave = this.materia.clave;
                this.creditosMateria = this.materia.creditos;
                this.descripcion = this.materia.descripcion;
                this.prerreqID = 0;
                this.selectedPrereqName = "",
                this.prerrequisitos = this.materia.prerrequisitos;

                this.selectedCourseName = this.nombreMateria;
                this.selectFirstPrereq();

                this.materiaLoaded = false;
            }
        },

        noPrerreqLoaded: function(value, oldValue)
        {
            if (this.noPrerreqLoaded)
            {
                this.nombrePrerreq = this.noPrerreq.materia;
                this.clavePrerreq = this.noPrerreq.clave;
                this.creditosPrerreq = this.noPrerreq.creditos;
                
                this.selectedNoPrereqName = this.nombrePrerreq;
                this.noPrerreqLoaded = false;
            }
        }
    }
};
</script>

<style scoped>
.sub-window {
    /* background-color: #e0e0e0; */
    /*grey lighten-2 */
    background: rgba(224, 224, 224, 0.6);
}
.catalogo_aocs {
    /* background: url('../assets/patiogallo2.jpg'); */
    background-color: white;
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>